<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-body">
        <input
          type="text"
          class="form-control search-input"
          @keyup.enter="search($event.target.value)"
          placeholder="Search...."
        />

        <button class="btn btn-success float-right mb-5" @click="print()">
          <i class="fa fa-print" aria-hidden="true"></i> Print
        </button>
        <span class="float-right follow-up">
          All &nbsp;<toggle-button
            v-model="followUp"
            @change="followUpChange"
          />
          &nbsp; Show Only Follow Up
        </span>
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>No.</th>
                <th>Age</th>
                <th>ORNR</th>
                <th>Fabric</th>
                <th>Box No.</th>
                <th>
                  <select
                    class="w-100"
                    @change="filterByColumn($event.target.value, 'box_color')"
                  >
                    <option :value="null">Box Color</option>
                    <option
                      class="text-capitalize"
                      :value="color.title_en"
                      v-for="color in dropDownData.boxColors"
                      :key="color.title_en"
                    >
                      {{ color.title_en }}
                    </option>
                  </select>
                </th>
                <th>Status</th>
                <th class="text-left">
                  <select
                    style="width: 150px"
                    @change="filterByColumn($event.target.value, 'reason_id')"
                  >
                    <option :value="null">Reason</option>
                    <option
                      class="text-capitalize"
                      :value="index"
                      v-for="(reason, index) in dropDownData.reasons"
                      :key="index"
                    >
                      # <span v-if="index != 0">{{ pad(index, 3) }} - </span>
                      {{ reason.title_en }}
                    </option>
                  </select>
                </th>
                <th>Started</th>
                <th>Finished</th>
                <th class="text-left">Days In Repair</th>
                <th>Repair Times</th>
                <th>Follow Up</th>
                <th>
                  <select
                    class="w-100"
                    @change="filterByColumn($event.target.value, 'status')"
                  >
                    <option value="in_repair">In Repair</option>
                    <option value="finished">Finished</option>
                    <option :value="null">All</option>
                  </select>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(repair, index) in repairs" :key="index">
                <td>{{ index + 1 }}.</td>
                <td>{{ repair.age }}</td>
                <td class="text-bold">
                  <router-link
                    :to="{ path: '/shirt/detail/' + repair.shirt_order_id }"
                  >
                    #{{ repair.shirt_order_id }}
                  </router-link>
                </td>
                <td>
                  <span v-if="repair.fabric_id != 0">
                    {{ repair.fabric_id }}
                  </span>
                </td>
                <td>{{ repair.box_number }}</td>
                <td
                  :class="'text-capitalize ' + textColor(repair.box_color)"
                  :style="'background:' + repair.box_color"
                >
                  {{ repair.box_color }}
                </td>
                <td>
                  <span v-if="repair.shirt_order_status.id != 0">
                    {{ repair.shirt_order_status.title }}
                  </span>
                </td>
                <td class="text-left reason">
                  <span v-if="repair.changeReason == true">
                    <select
                      style="width: 150px"
                      @change="changeReason($event.target.value, index)"
                    >
                      <option :value="null" selected>Select One</option>
                      <option
                        class="text-capitalize"
                        :value="reasonIndex"
                        v-for="(reason, reasonIndex) in dropDownData.reasons"
                        :key="reasonIndex"
                      >
                        #
                        <span v-if="reasonIndex != 0"
                          >{{ pad(reasonIndex, 3) }} -
                        </span>
                        {{ reason.title_en }}
                      </option>
                    </select>
                    <span
                      class="badge edit badge-danger pointer mt-6 float-right"
                      @click="repair.changeReason = false"
                    >
                      Cancel
                    </span>
                  </span>
                  <span v-else>
                    #<span v-if="repair.reason_id != 0"
                      >{{ pad(repair.reason_id, 3) }} -
                    </span>
                    {{ repair.reason.title_en }}

                    <span
                      class="badge edit badge-primary pointer float-right"
                      @click="repair.changeReason = true"
                    >
                      Edit
                    </span>
                  </span>
                </td>
                <td>{{ formatDate(repair.started_time) }}</td>
                <td>
                  <span v-if="repair.finished_time">
                    {{ formatDate(repair.finished_time) }}
                  </span>
                </td>
                <td class="text-left">{{ repair.time }}</td>
                <td>{{ repair.repair_times }}</td>
                <td>{{ repair.follow_up }}</td>
                <td>
                  <p
                    class="badge badge-danger info-tag"
                    v-if="repair.status == 'in_repair'"
                  >
                    In Repair
                  </p>
                  <p class="badge badge-primary info-tag" v-else>Finished</p>
                </td>
              </tr>
              <tr>
                <td colspan="13" v-if="noMoreData">NO MORE DATA</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dropDownData: {},
      repairs: [],
      params: {
        page: 1,
        perPage: 100,
        filters: [{ column: "status", keyword: "in_repair" }],
        sort: [],
      },
      canScroll: false,
      noMoreData: false,
      followUp: false,
    };
  },
  mounted() {
    this.getDropDownData();
    this.getRepairs();
    this.scroll();
  },
  methods: {
    search(keyword) {
      this.filterByColumn(keyword, "keyword");
    },

    followUpChange() {
      if (this.followUp) {
        this.filterByColumn("no", "follow_up");
      } else {
        this.filterByColumn(null, "follow_up");
      }
    },

    async changeReason(value, index) {
      let reason = this.dropDownData.reasons[value];
      let id = this.repairs[index].id;

      try {
        let res = await axios.post("shirt_orders/repair/change_reason/" + id, {
          reason_id: value,
        });
        if (res) {
          this.repairs[index].reason = reason;
          this.repairs[index].reason_id = value;
          this.repairs[index].changeReason = false;
          toastr.success("Successfully Changed!");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },

    async getDropDownData() {
      try {
        let res = await axios.get("shirt_orders/repair/dropdown");
        this.dropDownData = res.data;
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },

    async getRepairs() {
      try {
        let res = await axios.post("shirt_orders/repair/listings", this.params);
        let repairs = res.data;
        repairs.forEach((val) => {
          val["changeReason"] = false;
          this.repairs.push(val);
        });
        if (repairs.length < this.params.perPage) {
          this.noMoreData = true;
        } else {
          this.noMoreData = false;
        }
        this.canScroll = true;
        this.params.page++;
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },

    pad(number, width, padWith = "0") {
      number = number + "";
      return number.length >= width
        ? number
        : new Array(width - number.length + 1).join(padWith) + number;
    },

    formatDate(date) {
      return moment(date).utc().format("DD/MMM/YY HH:mm");
    },

    filterByColumn(value, column) {
      this.params.page = 1;
      this.repairs = [];
      let index = this.params.filters.findIndex((x) => x.column == column);
      if (index != -1) {
        this.params.filters.splice(index, 1);
      }
      this.params.filters.push({ column: column, keyword: value });
      this.getRepairs();
    },

    scroll() {
      window.onscroll = () => {
        var elem = document.getElementsByClassName("page-content")[0];
        if (this.canScroll == true && this.noMoreData == false) {
          if (
            document.documentElement.scrollTop +
              document.documentElement.offsetHeight >=
            elem.scrollHeight
          ) {
            this.canScroll = false;
            this.getRepairs();
          }
        }
      };
    },

    async print() {
      try {
        let res = await axios({
          url: "shirt_orders/repair/print",
          data: this.params,
          method: "POST",
          responseType: "blob", // important
        });
        if (res) {
          var url = URL.createObjectURL(res.data);
          window.open(url, "_blank");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        }
      }
    },

    textColor(boxColor) {
      if (boxColor === "yellow") {
        return "text-black";
      } else return "text-white";
    },
  },
};
</script>

<style scoped>
select:focus {
  background: white !important;
  background-color: white !important;
}
.w-100 {
  width: 100px;
}
.w-150 {
  width: 150px;
}
table select {
  text-transform: uppercase;
  font-size: 11px;
  font-weight: bold;
  height: 30px !important;
}
table tr th,
tr td {
  text-align: center;
  font-size: 12px !important;
  padding: 3px !important;
}
.mb-5 {
  margin-bottom: 5px;
}
.follow-up {
  margin-right: 20px;
  margin-top: 5px;
}
.search-input {
  width: 200px;
  float: left;
}
.reason .edit {
  display: none;
}
.reason:hover .edit {
  display: block;
}
</style>
